import React from "react";
import ProptradingHeader, { ProptradingHeaderRight } from "./_cmpt/ProptradingHeader";
import ProptradingBottomBar, { ProptradingTabKey } from "./_cmpt/ProptradingBottomBar";
import styles from "./ProptradingLayout.module.scss";

interface ProptradingLayoutProps {
  children: React.ReactNode;
  title?: string;
  activeTab?: ProptradingTabKey;
  /** 子页：左侧返回（默认回账户页） */
  showHeaderBack?: boolean;
  /** 右上角：默认关闭；收益兑换页为兑换记录入口 */
  headerRight?: ProptradingHeaderRight;
}

const ProptradingLayout: React.FC<ProptradingLayoutProps> = ({
  children,
  title = "Prop Trading",
  activeTab = "home",
  showHeaderBack = false,
  headerRight = "close",
}) => {
  return (
    <div className={styles.page}>
      <ProptradingHeader title={title} showBack={showHeaderBack} headerRight={headerRight} />
      <main className={styles.main}>{children}</main>
      <ProptradingBottomBar activeTab={activeTab} />
    </div>
  );
};

export default ProptradingLayout;
